import PropTypes from "prop-types";
import { Button, Dialog } from "@mui/material";

import { getRelationKeyByValue } from "utils/relativeUtils";
import { FACE_RELATIONS } from "enums";
import { useFaces, useFaceOrg } from "hooks";
import { MODAL_CONTENT } from "utils/ctaUtils";

import {
  StyledPaper,
  StyledSpinningCloseButton,
  Content,
  Figure,
  StyledResponsiveImage,
  StyledTitle,
  StyledDescription,
} from "./styles";

const CTAModal = (props) => {
  const { relation, onClose } = props;
  const { openModal: openFacesModal, clearRelationToCreate } = useFaces();

  const img = MODAL_CONTENT.img[relation];
  const title = MODAL_CONTENT.title[relation];
  const description = MODAL_CONTENT.description[relation];
  const { clearEntryPoint } = useFaceOrg();

  const handleClose = () => {
    clearRelationToCreate();
    onClose();
    clearEntryPoint();
  };

  const handleOpenModal = () => {
    openFacesModal();
    onClose();
  };

  return (
    <Dialog
      PaperComponent={StyledPaper}
      PaperProps={{ relation: getRelationKeyByValue(relation) }}
      open
      onBackdropClick={handleClose}
    >
      <StyledSpinningCloseButton onClick={handleClose} />

      <Content>
        <Figure>
          <StyledResponsiveImage src={img} alt={title} width={128} widthMobile={128} />
        </Figure>

        <StyledTitle align="center" variant="h4">
          {title}
        </StyledTitle>
        <StyledDescription variant="large" align="center">
          {description}
        </StyledDescription>

        <Button variant="contained" onClick={handleOpenModal}>
          Add Face
        </Button>
      </Content>
    </Dialog>
  );
};

CTAModal.propTypes = {
  relation: PropTypes.oneOf(Object.values(FACE_RELATIONS)).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CTAModal;
